import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import {
  DesktopOnly,
  tabletOrNarrower,
  TabletOrNarrowerOnly,
} from '@upright/ui/common/generic/layout/breakpoint-utils';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface Props {
  boxes: ReactNode[];
  overlayTitle?: ReactNode;
}

export function FigureBoxesWithExplanation(props: Props) {
  return (
    <div>
      <TabletOrNarrowerOnly>
        {props.overlayTitle && <OverlayTitle>{props.overlayTitle}</OverlayTitle>}
      </TabletOrNarrowerOnly>
      <Main>
        {props.boxes.map((box, index) => {
          return (
            <Box key={index} style={{ flexBasis: `${100 / props.boxes.length}%` }}>
              {box}
            </Box>
          );
        })}
        <DesktopOnly>{props.overlayTitle && <OverlayTitle>{props.overlayTitle}</OverlayTitle>}</DesktopOnly>
      </Main>
    </div>
  );
}

const OverlayTitle = styled.div`
  position: absolute;
  top: 0.25em;
  left: 0.4em;
  right: 0.4em;
  ${tabletOrNarrower(css`
    position: static;
    margin-top: 1em;
    margin-left: 1em;
    margin-right: 1em;
  `)};
  background-color: ${BouColor.TOOL_BACKGROUND_LIGHT_GRAY};
  color: black;
  padding: 0.5em 0.5em;
  border-radius: 4px;
  text-align: center;
  font-style: italic;
`;

const Box = styled.div`
  flex-basis: 50%;
  flex-grow: 0;
  flex-shrink: 0;
  overflow: hidden;
  & + & {
    border-left: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  }
`;

const Main = styled.div`
  border-left: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  border-right: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  display: flex;
  height: 100%;
  position: relative;
`;
